import React, {useContext, useMemo, useState} from 'react'
import {UserContext} from '../../context/User'
import {fill} from '../../utils/ApColor'
import EventBar from './EventBar'
import NewEventBar from './NewEventBar'
import useViewColor from './useViewColor'

const AllDayEvents = ({data, selectedDate, onClickEvent, dayCount = 1}) => {
  const [expanded, setExpanded] = useState(false)
  const user = useContext(UserContext)
  const color = useViewColor()

  const handleClickMore = () => {
    setExpanded(true)
  }
  const handleClickCollapse = () => {
    setExpanded(false)
  }

  const [CEventBarsCollapse, CEventBarsExpand, height] = useMemo(() => {
    let components = []

    let len = data.length
    // max show 3
    let max_show = 3
    let splice_indexes = Array.from({length: dayCount}).map(e => -1)
    let compact = Array.from({length: max_show + 1}).map(e =>
      Array.from({length: dayCount}).map(e => 0)
    )

    for (let ci = 0; ci < len; ci++) {
      const col = data[ci]
      let c = []
      let row_counter = 0
      for (let i = 0; i < col.length; i++) {
        const ev = col[i]
        const s = ci + 1
        const e = s + Math.ceil(ev.bottom / 100)

        // check if there's an item in the current row
        while (compact[row_counter][s - 1] > 0 && row_counter < max_show) {
          row_counter++
        }

        for (let j = s - 1; j < Math.min(e - 1, dayCount); j++) {
          if (row_counter < max_show) {
            compact[row_counter][j]++
          } else {
            compact[max_show][j]++
          }
        }

        if (splice_indexes[ci] === -1 && row_counter >= max_show - 1) {
          splice_indexes[ci] = i
        }
        c.push(
          <EventBar
            key={i}
            data={{...ev}}
            style={{gridColumn: `${s}/${e}`}}
            selectedDate={selectedDate}
            onClick={onClickEvent}
            dayCount={dayCount}
          />
        )
      }

      components.push(c)
    }

    const expand_items = components
    let rows = compact.reduce((t, r) => Math.max(...r) + t, 0)
    let has_more = rows > max_show
    let cut = has_more ? max_show - 1 : max_show
    const collapse_items = expand_items.map((c, i) => {
      let splice_index = Math.max(0, has_more ? splice_indexes[i] : splice_indexes[i] + 1)
      let hidden = compact.slice(cut, max_show + 1).reduce((a, e) => a + e[i], 0)

      if (hidden === 0) {
        return c
      } else {
        let r = c.slice(0, splice_index)
        r.push(
          <div
            key={i}
            className="event-bar event-bar--more"
            style={{gridColumn: `${i + 1}/${i + 2}`}}
            onClick={handleClickMore}
          >
            {hidden} more
          </div>
        )
        return r
      }
    })

    return [collapse_items, expand_items, rows * 22 + 1]
  }, [data, onClickEvent, selectedDate, dayCount])

  return (
    <>
      {expanded && <div className="all-day-events__spacer"></div>}
      <div
        className={`all-day-events ${expanded ? 'all-day-events--expanded' : ''}`}
        style={{height: expanded ? height + 22 : height}}
      >
        <div className="time-column">
          <div className="time-label time-label--small" style={{fontSize: 10}}>
            {user.details?.gmt && `GMT${user.details?.gmt.slice(0, -2)}`}
          </div>
        </div>
        {data.map((e, i) => (
          <div key={i} className="day-column" />
        ))}
        <div
          className="events-bar-container"
          style={{'--columns': dayCount}}
          data-x="all-day-range"
        >
          <NewEventBar
            style={{display: 'none', backgroundColor: fill(color, 0.35), borderColor: color}}
          />
          {expanded ? CEventBarsExpand : CEventBarsCollapse}
        </div>
        {expanded && (
          <div className="all-day-events__btn-collapse" onClick={handleClickCollapse}>
            Collapse
          </div>
        )}
      </div>
    </>
  )
}

export default AllDayEvents
